import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { EditorialMarquee } from "./components/site/EditorialMarquee";
import { About } from "./components/site/About";
import { Services } from "./components/site/Services";
import { CCheck } from "./components/site/CCheck";
import { Fleet } from "./components/site/Fleet";
import { Gallery } from "./components/site/Gallery";
import { Manifesto } from "./components/site/Manifesto";
import { Sales } from "./components/site/Sales";
import { Quote } from "./components/site/Quote";
import { Faq } from "./components/site/Faq";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { WhatsAppButton } from "./components/site/WhatsAppButton";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#020617] text-slate-50 min-h-screen relative noise-overlay">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Services />
        <CCheck />
        <Fleet />
        <Gallery />
        <Manifesto />
        <Sales />
        <Quote />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-left" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
